<template>
    
        <ul class="nav_breadcrumbs">
            <li><router-link to="/modules/home">{{lang.LBL_HOME}}</router-link></li>
            <li><router-link to="/modules/multibranchs/edit">{{lang.LBL_ADD_MULTIBRANCH}}</router-link></li>
            <li><router-link to="/modules/multibranchs">{{lang.LBL_VIEW_MULTIBRANCH}}</router-link></li>
        </ul>
</template>
<script>
import lang from "@/views/modules/MultiBranchs/language/en";

export default {
    name: "breadcrumbs",
    
    data() {
        return {
            lang:[],
           
        }
     },
     mounted() {
        this.lang = lang;
       
    },
    methods:{
       
    }
     
}
</script>
